import React, { useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Info, X } from 'lucide-react';

const TranslationHelper = () => {
  const { language } = useLanguage();
  const [showInstructions, setShowInstructions] = useState(false);

  // Show instructions when language is changed to non-English
  React.useEffect(() => {
    if (language !== 'English') {
      setShowInstructions(true);
      // Auto-hide after 10 seconds
      setTimeout(() => {
        setShowInstructions(false);
      }, 10000);
    } else {
      setShowInstructions(false);
    }
  }, [language]);

  if (!showInstructions) return null;

  return (
    <div className="fixed top-20 right-4 z-50 bg-blue-50 border border-blue-200 rounded-lg p-4 max-w-sm shadow-lg">
      <div className="flex items-start justify-between">
        <div className="flex items-start space-x-3">
          <Info className="w-5 h-5 text-blue-600 mt-0.5 flex-shrink-0" />
          <div>
            <h3 className="text-sm font-medium text-blue-900 mb-2">
              Browser Translation Help
            </h3>
            <div className="text-xs text-blue-700 space-y-2">
              <p>
                To see the page translated to {language === '繁體' ? 'Traditional Chinese' : 'Simplified Chinese'}:
              </p>
              <ol className="list-decimal list-inside space-y-1">
                <li>Right-click anywhere on the page</li>
                <li>Select "Translate to {language === '繁體' ? 'Chinese (Traditional)' : 'Chinese (Simplified)'}"</li>
                <li>Or use your browser's translation feature</li>
              </ol>
              <p className="text-blue-600 font-medium mt-2">
                💡 Tip: Enable "Always translate" for automatic translation
              </p>
            </div>
          </div>
        </div>
        <button
          onClick={() => setShowInstructions(false)}
          className="text-blue-400 hover:text-blue-600 transition-colors"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default TranslationHelper; 